import Vue from "vue";
import Router from "vue-router";
import Playlist from "./views/Playlist.vue";
import Saved from "./views/Saved.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "playlist",
      component: Playlist
    },
    {
      path: "/saved",
      name: "saved",
      component: Saved
    },
    {
      path: "/concerts",
      name: "concerts",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Concerts.vue")
    },
    {
      path: "/:lat_lng",
      name: "playlist",
      component: Playlist
    },
    {
      path: "/concerts/:lat_lng",
      name: "concerts",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Concerts.vue")
    },
    {
      path: "/concerts/:city",
      name: "concerts",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Concerts.vue")
    },
    {
      path: "/:lat_lng/:genres",
      name: "playlist",
      component: Playlist
    },
    {
      path: "/concerts/:lat_lng/:genres",
      name: "concerts",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Concerts.vue")
    }
  ]
});
